import React from 'react'

// material ui
import Input from '@mui/material/Input'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'

import { styled } from '@mui/material/styles'

const DaysInput = styled(Input)(({ theme }) => ({
  width: theme.spacing(6),
  background: 'background',
  '& .MuiInput-input': {
    fontSize: '18px',
    textAlign: 'center'
  }
}))

const SelectDays = props => {
  const { cartProduct, onChangeDays, camper, session, product, productType } =
    props

  // for integration tests
  const inputProps = {
    'data-test-id': `camper-${camper.id}-session-${session.id}-product-${product.id}-days`
  }

  const inputValue =
    Number.isNaN(cartProduct.days) || productType !== cartProduct.selectedType
      ? ''
      : cartProduct.days

  return (
    <Box width={4} display='inline'>
      <FormControl>
        <DaysInput
          type='number'
          value={inputValue}
          onChange={onChangeDays}
          inputProps={inputProps}
          disabled={productType !== cartProduct.selectedType}
        />
      </FormControl>
    </Box>
  )
}

export default SelectDays
